import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { App } from '@/sidepanel/App';
import { Login } from './Login';
import { Settings } from './Settings';
import { getMe, logout } from './auth';
import { Wordmark } from '@/components/Brand';

interface Me {
  id: string;
  email: string;
}

export function Webapp() {
  const [me, setMe] = useState<Me | null | undefined>(undefined);

  useEffect(() => {
    void (async () => {
      const m = await getMe();
      setMe(m);
    })();
  }, []);

  if (me === undefined) {
    return <div className="p-4 text-sm text-slate-500">Loading…</div>;
  }
  if (me === null) {
    return <Login />;
  }

  return (
    // h-[100dvh] (dynamic viewport height) instead of h-screen/100vh so the
    // layout isn't clipped under the iOS Safari dynamic toolbar.
    <div className="flex h-[100dvh] flex-col">
      <div className="flex items-center justify-between border-b border-slate-200 bg-slate-50 px-3 py-1 text-xs text-slate-500">
        <div className="flex min-w-0 items-center gap-2">
          <Link to="/" aria-label="Home">
            <Wordmark glyphSize={20} className="text-sm" />
          </Link>
          {/* Identity is informational — hide it on narrow viewports so the bar
              stays slim (matches App's @3xl ≈ 768px layout switch). */}
          <span className="hidden text-slate-400 md:inline">·</span>
          <span className="hidden truncate md:inline">signed in as {me.email}</span>
        </div>
        <button
          className="hover:text-slate-800"
          onClick={async () => {
            await logout();
            window.location.assign('/login');
          }}
        >
          sign out
        </button>
      </div>
      <div className="flex-1 overflow-auto">
        {/* Settings is injected into App's route table so it renders inside
            the shared shell and keeps the nav header. */}
        <App settingsElement={<Settings />} />
      </div>
    </div>
  );
}
